import { render, staticRenderFns } from "./OrganizationDetails.vue?vue&type=template&id=b499ae14&scoped=true"
import script from "./OrganizationDetails.vue?vue&type=script&lang=js"
export * from "./OrganizationDetails.vue?vue&type=script&lang=js"
import style0 from "./OrganizationDetails.vue?vue&type=style&index=0&id=b499ae14&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b499ae14",
  null
  
)

export default component.exports